







































































































import { Component, Vue } from "vue-property-decorator";
import NavIcon from "./navigation/NavIcon.vue";
import { AuthModule } from "@/store/auth.module";
import { ContractsModule } from "@/store/contracts.module";
import PayDialog from "@/components/reports/PayForm.vue";
import { BaseModule } from "@/store/base.module";
import { AppealsModule } from "@/store/appeals.module";

@Component({
  components: {
    NavIcon,
    PayDialog,
  },
})
export default class ApNavigation extends Vue {
  dialogShow: boolean = false;

  // User info
  get isLoggedIn() {
    return AuthModule.isLoggedIn;
  }

  get user() {
    return AuthModule.user as IUser;
  }

  get userOrgName() {
    if (this.user.org_name.length >= 100) {
      const slice = this.user.org_name.slice(0, 97);
      return slice + "...";
    }
    return this.user.org_name;
  }

  // Contracts
  get contracts() {
    return ContractsModule.contracts;
  }

  get selectedContract() {
    return ContractsModule.selectedContract;
  }

  set selectedContract(value: number | null) {
    ContractsModule.selectContractAndRoute(value);
  }

  goToContracts() {
    this.$router.push("/contracts");
  }

  goToProfile() {
    this.$router.push("/profile");
  }

  goToAppeal() {
    let c = "0";
    if (this.$route.params.id) c = this.$route.params.id;
    else {
      if (ContractsModule.contracts && ContractsModule.contracts.length > 0)
        c = ContractsModule.contracts[0].contract_rid.toString();
    }
    this.$router.push("/contracts/" + c + "/appeal");
  }

  loaded: boolean = false;

  async goToPay() {
    this.loaded = true;
    let c = "0";
    if (this.$route.params.id) c = this.$route.params.id;
    else {
      if (ContractsModule.contracts && ContractsModule.contracts.length > 0)
        c = ContractsModule.contracts[0].contract_rid.toString();
    }

    await ContractsModule.getCurPeriod(c);

    await ContractsModule.getPayDetail({
      contractRid: Number.parseInt(c),
      date: ContractsModule.curPeriod.cur_period,
    }).then(() => {
      this.loaded = false;
      if (
        ContractsModule.payDetail &&
        ContractsModule.payDetail.sum_pay &&
        ContractsModule.payDetail.sum_pay != 0
      ) {
        ContractsModule.setShowPayDialog(true);
      } else this.dialogShow = true;
    });
  }

  async logout() {
    ContractsModule.logout();
  }

  async mounted() {
    if (AuthModule.user && AuthModule.user.bin) {
      await ContractsModule.getQuestionnaire(AuthModule.user.bin);
      await AppealsModule.getRequestsNotice();
      //console.log("appealInCount", AppealsModule.appealInCount);
    }
  }

  get appealInCount() {
    return AppealsModule.appealInCount;
  }
}
